import { BADGE_TYPES, BADGE_PLACEHOLDER } from '../constants/BadgesConstants';

const URL_BUST_VALUE = window.URL_BUST_VALUE;

export const isRepeatableBadge = (badge) => {
    return badge.badgeTypeIds.includes(BADGE_TYPES.REPEATABLE);
};

export const getBadgeImagePlaceholderUrl = () => {
    return `${BADGE_PLACEHOLDER}?bust=${URL_BUST_VALUE}`;
};

export const getBadgeImageUrl = (badgeId, size = 'lrg', badgeUUid) => {
    if (!badgeId && !badgeUUid) {
        throw 'getBadgeImageUrl(badgeId): badgeId not specified';
    }
    //new badges have uuids in route - if available use that else use old format
    if (badgeUUid) {
        return `/images/badges/xxhdpi/badge_${badgeUUid}_${size}.png?bust=${URL_BUST_VALUE}`;
    }

    return `/images/badges/xxhdpi/badge_${badgeId}_${size}.png?bust=${URL_BUST_VALUE}`;
};

export const getBadgeBannerImageUrl = (challengeCategoryId, challengeCategoryImageId, isDesktop = true) => {
    return `/images/badges/web/art_badge_challenge_${
        isDesktop ? 'desktop' : 'mobile'
    }_category_${challengeCategoryId}_${challengeCategoryImageId}.png?bust=${URL_BUST_VALUE}`;
};

export const getBadgePartnerImageUrl = (badgeUUid) => {
    return `/images/badges/xxhdpi/logo_${badgeUUid}_lrg.png?bust=${URL_BUST_VALUE}`;
};

export const isLimitedTimeBadge = (badge) => {
    const badgeTypes = badge.badgeTypeIds;

    return badgeTypes.includes(BADGE_TYPES.LIMITED_ANNUAL) || badgeTypes.includes(BADGE_TYPES.LIMITED_SINGLE);
};

export const isLimitedAnnualBadge = (badge) => {
    const badgeTypes = badge.badgeTypeIds;

    return badgeTypes.includes(BADGE_TYPES.LIMITED_ANNUAL);
};

/**
 * Given a key,provides the correct badge title.
 * The method is needed because the API returns the keyName and all the badges have the 'badge_title' + keyName signature
 * @param keyName the key for badge title.
 */
export const localizeBadgeTitle = (keyName, Localizer) => {
    return Localizer.localize('badge_title_' + keyName);
};

/**
 * Given a key,provides the correct badge title.
 * The method is needed because the API returns the keyName and all the badges have the 'badge_title' + keyName signature
 * @param keyName the key for badge title.
 */
export const localizeBadgeTitleReact = (keyName, i18next) => {
    return i18next.t('badges-list:badge_title_' + keyName);
};

/**
 * Given a key, provides the correct badge description.
 * The method is needed because the API returns the keyName and all the badges have the 'badge_description' + keyName signature
 * @param keyName the key for badge description.
 */
export const localizeBadgeDescription = (keyName, Localizer) => {
    return Localizer.localize('badge_description_' + keyName);
};

/**
 * Given a key, provides the correct badge description.
 * The method is needed because the API returns the keyName and all the badges have the 'badge_description' + keyName signature
 * @param keyName the key for badge description.
 */
export const localizeBadgeDescriptionReact = (keyName, i18next) => {
    return i18next.t('badges-list:badge_description_' + keyName);
};

/**
 * check if badge is challenge badge
 * @param {{ badgeCategoryId:number; badgeAssocTypeId: number }} badge
 */
export const isChallengeBadge = (badge) => {
    return badge.badgeCategoryId === 4;
};

/**
 * check if badge is badge-challenge badge
 * @param {{ badgeCategoryId:number; badgeAssocTypeId: number }} badge
 */
export const isBadgeChallengeBadge = (badge) => {
    return badge.badgeCategoryId === 4 && badge.badgeAssocTypeId === 9;
};

/**
 * check if badge is retired
 * @param {import ('./BadgeDTO').BadgeDTO} badge
 */
export const isRetiredBadge = (badge) => {
    if (badge.badgeEndDate === null) {
        return false;
    }
    const endDate = new Date(badge.badgeEndDate);
    const now = new Date();

    return now > endDate;
};

/**
 *
 * @param {import('./BadgeDTO').BadgeDTO} badge
 */
export const isPremiumBadge = (badge) => {
    return badge.premium;
};
